const storageKeys = {
  authToken: "authToken",
  authAdminToken: "authAdminToken",
  authTenantToken: "authTenantToken",
};

export default storageKeys;
